module.exports = __webpack_public_path__ + "static/03-handoff-small-7384948d6969354a0a37ed54745716b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/03-handoff-small.jpg
// module id = 2641
// module chunks = 35783957827783